'use es6';

import { connect } from 'react-redux';
import WidgetBranding from 'conversations-visitor-experience-components/visitor-widget/WidgetBranding';
import { viralChatLink } from '../../selectors/widgetDataSelectors/trackingPixel/getViralLink';
import { getWidgetDataLanguage } from '../../widget-data/selectors/widgetDataSelectors';
const mapStateToProps = state => {
  return {
    liveChatHref: viralChatLink(state),
    lang: getWidgetDataLanguage(state)
  };
};
export default connect(mapStateToProps)(WidgetBranding);